import { IconProps } from '@chakra-ui/react';
import { Icon } from '@diamond/shared/ui';

export const Voucher = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.00016 8.93229C7.18905 8.93229 7.34738 8.8684 7.47516 8.74062C7.60294 8.61285 7.66683 8.45451 7.66683 8.26562C7.66683 8.07674 7.60294 7.9184 7.47516 7.79062C7.34738 7.66285 7.18905 7.59896 7.00016 7.59896C6.81127 7.59896 6.65294 7.66285 6.52516 7.79062C6.39738 7.9184 6.3335 8.07674 6.3335 8.26562C6.3335 8.45451 6.39738 8.61285 6.52516 8.74062C6.65294 8.8684 6.81127 8.93229 7.00016 8.93229ZM7.00016 6.26562C7.18905 6.26562 7.34738 6.20174 7.47516 6.07396C7.60294 5.94618 7.66683 5.78785 7.66683 5.59896C7.66683 5.41007 7.60294 5.25174 7.47516 5.12396C7.34738 4.99618 7.18905 4.93229 7.00016 4.93229C6.81127 4.93229 6.65294 4.99618 6.52516 5.12396C6.39738 5.25174 6.3335 5.41007 6.3335 5.59896C6.3335 5.78785 6.39738 5.94618 6.52516 6.07396C6.65294 6.20174 6.81127 6.26562 7.00016 6.26562ZM7.00016 3.59896C7.18905 3.59896 7.34738 3.53507 7.47516 3.40729C7.60294 3.27951 7.66683 3.12118 7.66683 2.93229C7.66683 2.7434 7.60294 2.58507 7.47516 2.45729C7.34738 2.32951 7.18905 2.26562 7.00016 2.26562C6.81127 2.26562 6.65294 2.32951 6.52516 2.45729C6.39738 2.58507 6.3335 2.7434 6.3335 2.93229C6.3335 3.12118 6.39738 3.27951 6.52516 3.40729C6.65294 3.53507 6.81127 3.59896 7.00016 3.59896ZM12.3335 10.9323H1.66683C1.30016 10.9323 0.986274 10.8017 0.725163 10.5406C0.464052 10.2795 0.333496 9.96562 0.333496 9.59896V6.93229C0.700163 6.93229 1.01405 6.80174 1.27516 6.54063C1.53627 6.27951 1.66683 5.96562 1.66683 5.59896C1.66683 5.23229 1.53627 4.9184 1.27516 4.65729C1.01405 4.39618 0.700163 4.26562 0.333496 4.26562V1.59896C0.333496 1.23229 0.464052 0.918403 0.725163 0.657292C0.986274 0.396181 1.30016 0.265625 1.66683 0.265625H12.3335C12.7002 0.265625 13.0141 0.396181 13.2752 0.657292C13.5363 0.918403 13.6668 1.23229 13.6668 1.59896V4.26562C13.3002 4.26562 12.9863 4.39618 12.7252 4.65729C12.4641 4.9184 12.3335 5.23229 12.3335 5.59896C12.3335 5.96562 12.4641 6.27951 12.7252 6.54063C12.9863 6.80174 13.3002 6.93229 13.6668 6.93229V9.59896C13.6668 9.96562 13.5363 10.2795 13.2752 10.5406C13.0141 10.8017 12.7002 10.9323 12.3335 10.9323ZM12.3335 9.59896V7.89896C11.9224 7.65451 11.5974 7.32951 11.3585 6.92396C11.1196 6.5184 11.0002 6.07674 11.0002 5.59896C11.0002 5.12118 11.1196 4.67951 11.3585 4.27396C11.5974 3.8684 11.9224 3.5434 12.3335 3.29896V1.59896H1.66683V3.29896C2.07794 3.5434 2.40294 3.8684 2.64183 4.27396C2.88072 4.67951 3.00016 5.12118 3.00016 5.59896C3.00016 6.07674 2.88072 6.5184 2.64183 6.92396C2.40294 7.32951 2.07794 7.65451 1.66683 7.89896V9.59896H12.3335Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export const AddToCartIcon = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="add-to-cart-mask"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#add-to-cart-mask)">
        <path
          d="M11 9V6H8V4H11V1H13V4H16V6H13V9H11ZM7 22C6.45 22 5.97917 21.8042 5.5875 21.4125C5.19583 21.0208 5 20.55 5 20C5 19.45 5.19583 18.9792 5.5875 18.5875C5.97917 18.1958 6.45 18 7 18C7.55 18 8.02083 18.1958 8.4125 18.5875C8.80417 18.9792 9 19.45 9 20C9 20.55 8.80417 21.0208 8.4125 21.4125C8.02083 21.8042 7.55 22 7 22ZM17 22C16.45 22 15.9792 21.8042 15.5875 21.4125C15.1958 21.0208 15 20.55 15 20C15 19.45 15.1958 18.9792 15.5875 18.5875C15.9792 18.1958 16.45 18 17 18C17.55 18 18.0208 18.1958 18.4125 18.5875C18.8042 18.9792 19 19.45 19 20C19 20.55 18.8042 21.0208 18.4125 21.4125C18.0208 21.8042 17.55 22 17 22ZM1 4V2H4.275L8.525 11H15.525L19.425 4H21.7L17.3 11.95C17.1167 12.2833 16.8708 12.5417 16.5625 12.725C16.2542 12.9083 15.9167 13 15.55 13H8.1L7 15H19V17H7C6.25 17 5.67917 16.675 5.2875 16.025C4.89583 15.375 4.88333 14.7167 5.25 14.05L6.6 11.6L3 4H1Z"
          fill="currentColor"
        />
      </g>
    </Icon>
  );
};

export const CheckIconVoucher = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_8812_29188"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8812_29188)">
        <path
          d="M15 2C16.9289 2 18.6007 2.68664 19.957 4.04297C21.3134 5.3993 22 7.07114 22 9V15C22 16.9289 21.3134 18.6007 19.957 19.957C18.6007 21.3134 16.9289 22 15 22H9C7.07114 22 5.3993 21.3134 4.04297 19.957C2.68664 18.6007 2 16.9289 2 15V9C2 7.07114 2.68664 5.3993 4.04297 4.04297C5.3993 2.68664 7.07114 2 9 2H15Z"
          fill="#34C759"
          stroke="white"
          strokeWidth="2"
        />
      </g>
    </Icon>
  );
};

export const ChecklistIconVoucher = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.333 1C26.5582 1 29.332 2.14056 31.5957 4.4043C33.8594 6.66804 35 9.44184 35 12.667V23.333C35 26.5582 33.8594 29.332 31.5957 31.5957C29.332 33.8594 26.5582 35 23.333 35H12.667C9.44184 35 6.66804 33.8594 4.4043 31.5957C2.14056 29.332 1 26.5582 1 23.333V12.667C1 9.44184 2.14056 6.66804 4.4043 4.4043C6.66804 2.14056 9.44184 1 12.667 1H23.333ZM24.4004 13.7109C24.1348 13.7109 23.9824 13.7872 23.8623 13.9072L16.9297 20.8408L16.2227 21.5479L15.5146 20.8408L12.8486 18.1738C12.7286 18.0538 12.5768 17.9776 12.3115 17.9775C12.0459 17.9775 11.8935 18.0538 11.7734 18.1738C11.6535 18.2938 11.5782 18.4456 11.5781 18.7109C11.5781 18.9762 11.6536 19.128 11.7734 19.248L15.6846 23.1592C15.8652 23.3398 16.0311 23.4004 16.2227 23.4004C16.414 23.4003 16.5793 23.3397 16.7598 23.1592L24.9375 14.9814C25.0574 14.8614 25.1338 14.7097 25.1338 14.4443C25.1338 14.1789 25.0575 14.0273 24.9375 13.9072C24.8175 13.7872 24.6657 13.711 24.4004 13.7109Z"
        fill="#34C759"
        stroke="white"
        strokeWidth="2"
      />
    </Icon>
  );
};

export const VoucherIcon = (props: IconProps) => {
  return (
    <Icon
      as="svg"
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.33333 10.8333C8.56944 10.8333 8.76736 10.7535 8.92708 10.5938C9.08681 10.434 9.16667 10.2361 9.16667 10C9.16667 9.76389 9.08681 9.56597 8.92708 9.40625C8.76736 9.24653 8.56944 9.16667 8.33333 9.16667C8.09722 9.16667 7.89931 9.24653 7.73958 9.40625C7.57986 9.56597 7.5 9.76389 7.5 10C7.5 10.2361 7.57986 10.434 7.73958 10.5938C7.89931 10.7535 8.09722 10.8333 8.33333 10.8333ZM8.33333 7.5C8.56944 7.5 8.76736 7.42014 8.92708 7.26042C9.08681 7.10069 9.16667 6.90278 9.16667 6.66667C9.16667 6.43056 9.08681 6.23264 8.92708 6.07292C8.76736 5.91319 8.56944 5.83333 8.33333 5.83333C8.09722 5.83333 7.89931 5.91319 7.73958 6.07292C7.57986 6.23264 7.5 6.43056 7.5 6.66667C7.5 6.90278 7.57986 7.10069 7.73958 7.26042C7.89931 7.42014 8.09722 7.5 8.33333 7.5ZM8.33333 4.16667C8.56944 4.16667 8.76736 4.08681 8.92708 3.92708C9.08681 3.76736 9.16667 3.56944 9.16667 3.33333C9.16667 3.09722 9.08681 2.89931 8.92708 2.73958C8.76736 2.57986 8.56944 2.5 8.33333 2.5C8.09722 2.5 7.89931 2.57986 7.73958 2.73958C7.57986 2.89931 7.5 3.09722 7.5 3.33333C7.5 3.56944 7.57986 3.76736 7.73958 3.92708C7.89931 4.08681 8.09722 4.16667 8.33333 4.16667ZM15 13.3333H1.66667C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V8.33333C0.458333 8.33333 0.850694 8.17014 1.17708 7.84375C1.50347 7.51736 1.66667 7.125 1.66667 6.66667C1.66667 6.20833 1.50347 5.81597 1.17708 5.48958C0.850694 5.16319 0.458333 5 0 5V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H15C15.4583 0 15.8507 0.163194 16.1771 0.489583C16.5035 0.815972 16.6667 1.20833 16.6667 1.66667V5C16.2083 5 15.816 5.16319 15.4896 5.48958C15.1632 5.81597 15 6.20833 15 6.66667C15 7.125 15.1632 7.51736 15.4896 7.84375C15.816 8.17014 16.2083 8.33333 16.6667 8.33333V11.6667C16.6667 12.125 16.5035 12.5174 16.1771 12.8438C15.8507 13.1701 15.4583 13.3333 15 13.3333Z"
        fill="#34C759"
      />
    </Icon>
  );
};
